import {
  MdPhone,
  MdMail,
  MdLocationOn,
  MdBusiness,
  MdPeople,
} from 'react-icons/md'

const Contact = () => {
  return (
    <section className='contact' id='contact'>
      <h2>Kontakty</h2>
      <h3>Neváhejte se nám ozvat</h3>

      <div className='contact-box'>
        <div className='contact-box-l'>
          <div className='contact-box-header'>
            <MdPeople /> Naše vedení
          </div>
          <div className='contact-box-item'>
            <div className='contact-box-item-name'>Alena Dubnová</div>
            <div className='contact-box-item-position contact-mar-b'>
              obchod a logistika
            </div>
            <a
              href='tel:+420601565735'
              className='contact-box-item-link contact-mar-b'
            >
              <MdPhone /> +420 601 565 735
            </a>
            <a
              href='mailto:cnc.duben@seznam.cz'
              className='contact-box-item-link'
            >
              <MdMail /> cnc.duben@seznam.cz
            </a>
          </div>

          <div className='contact-box-item'>
            <div className='contact-box-item-name'>Josef Duben</div>
            <div className='contact-box-item-position contact-mar-b'>
              výrobní úsek
            </div>
            <a
              href='tel:+420739237611'
              className='contact-box-item-link contact-mar-b'
            >
              <MdPhone /> +420 739 237 611
            </a>
            <a
              href='mailto:vyroba@cncduben.cz'
              className='contact-box-item-link'
            >
              <MdMail /> vyroba@cncduben.cz
            </a>
          </div>

          <div className='contact-box-item'>
            <div className='contact-box-item-name'>Eliška Hájková</div>
            <div className='contact-box-item-position contact-mar-b'>
              fakturace a účetnictví
            </div>
            <a
              href='tel:+420732709545'
              className='contact-box-item-link contact-mar-b'
            >
              <MdPhone /> +420 732 709 545
            </a>
            <a
              href='mailto:ucetni@cncduben.cz'
              className='contact-box-item-link'
            >
              <MdMail /> ucetni@cncduben.cz
            </a>
          </div>
        </div>

        <div className='contact-box-c'>
          <div className='contact-box-header'>
            <MdBusiness /> Fakturační adresa
          </div>
          <div className='contact-box-section'>
            <p>CNC obrábění DUBEN, spol. s r.o.</p>
            <p>Jasenná 325</p>
            <p>552 22 Jasenná</p>
            <div className='contact-box-ids'>
              <span>
                <strong>IČ:</strong> 27509648
              </span>
              <span>
                <strong>DIČ:</strong> CZ27509648
              </span>
              <a
                href='https://or.justice.cz/ias/ui/rejstrik-firma.vysledky?subjektId=131244&typ=PLATNY'
                target='_blank'
                rel='noreferrer'
                className='contact-box-or-link'
              >
                Výpis z OR &rarr;
              </a>
            </div>
          </div>

          <div className='contact-box-header contact-box-header--secondary'>
            <MdLocationOn /> Provozovna
          </div>
          <div className='contact-box-section'>
            <p>CNC obrábění DUBEN, spol. s r.o.</p>
            <p>Jasenná 325</p>
            <p>552 22 Jasenná</p>
          </div>
        </div>

        <div className='contact-box-r'>
          <div className='contact-box-r-overlay'></div>{' '}
          <iframe
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2547.7129199927667!2d15.997159977289531!3d50.315949271566716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470e7c231c65b70f%3A0x4e3573ce045904cc!2zQ05DIG9icsOhYsSbbsOtIERVQkVOLCBzcG9sLiBzIHIuby4!5e0!3m2!1scs!2scz!4v1772190285393!5m2!1scs!2scz'
            allowFullScreen=''
            loading='lazy'
            title='map'
          ></iframe>
        </div>
      </div>
    </section>
  )
}

export default Contact
